/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IIndexedNode } from '../../../core/models/IIndexedNode';
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';
import { Oas20Header } from './Oas20Header';
import { Document } from '../../../core/models/Document';

/**
 * Constructor.
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export class Oas20Headers extends Node implements IIndexedNode<Oas20Header> {
    /*private*/ items : any = <any>({});

    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitHeaders(this);
    }

    /**
     * Creates a header model.
     * @param {string} headerName
     * @return {Oas20Header}
     */
    public createHeader(headerName : string) : Oas20Header {
        let rval : Oas20Header = new Oas20Header(headerName);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Gets a single header by name.
     * @param {string} headerName
     * @return {Oas20Header}
     */
    public getHeader(headerName : string) : Oas20Header {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, headerName);
    }

    /**
     * Returns an array of all the headers.
     * @return {Oas20Header[]}
     */
    public getHeaders() : Array<Oas20Header> {
        let rval : Array<Oas20Header> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        return rval;
    }

    /**
     * Returns all the header names.
     * @return {string[]}
     */
    public getHeaderNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Removes a single header.
     * @param {string} headerName
     * @return {Oas20Header}
     */
    public removeHeader(headerName : string) : Oas20Header {
        return /* remove */(map => { let deleted = this.items[headerName];delete this.items[headerName];return deleted;})(this.items);
    }

    /**
     * Adds a header.
     * @param {string} headerName
     * @param {Oas20Header} header
     * @return {Oas20Header}
     */
    public addHeader(headerName : string, header : Oas20Header) : Oas20Header {
        /* put */(this.items[headerName] = header);
        return header;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {Oas20Header}
     */
    public getItem(name : string) : Oas20Header {
        return this.getHeader(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {Oas20Header[]}
     */
    public getItems() : Array<Oas20Header> {
        return this.getHeaders();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getHeaderNames();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20Header(name : string, item : Oas20Header) {
        this.addHeader(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {Oas20Header} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>Oas20Header) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20Header(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {Oas20Header}
     */
    public deleteItem(name : string) : Oas20Header {
        return this.removeHeader(name);
    }
}
Oas20Headers["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Headers";
Oas20Headers["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];




